var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_8268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5625 11.4375C10.9076 11.4375 11.1875 11.1577 11.1875 10.8125C11.1875 10.4673 10.9076 10.1875 10.5625 10.1875C10.2173 10.1875 9.93747 10.4673 9.93747 10.8125C9.93747 11.1577 10.2173 11.4375 10.5625 11.4375Z",
    fill: "#3F4752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.43747 14.75H2.49999C1.81074 14.75 1.25 14.1892 1.25 13.5V8.375C1.25 7.68575 1.81074 7.125 2.49999 7.125H11.5C12.1892 7.125 12.7499 7.68575 12.7499 8.375V9.62499C12.7499 9.97018 13.0298 10.25 13.3749 10.25C13.7201 10.25 13.9999 9.97018 13.9999 9.62499V8.375C13.9999 6.9965 12.8784 5.87501 11.5 5.87501H10.7488V3.67083C10.7488 1.64674 9.06656 3.05176e-05 6.99882 3.05176e-05C4.93107 3.05176e-05 3.24883 1.64674 3.24883 3.67083V5.87501H2.49999C1.1215 5.87501 0 6.9965 0 8.375V13.5C0 14.8785 1.1215 16 2.49999 16H7.43747C7.78266 16 8.06247 15.7202 8.06247 15.375C8.06247 15.0298 7.78266 14.75 7.43747 14.75ZM4.49883 3.67083C4.49883 2.33599 5.62032 1.25003 6.99882 1.25003C8.37731 1.25003 9.49881 2.33599 9.49881 3.67083V5.87501H4.49883V3.67083Z",
    fill: "#3F4752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7388 10.1793C15.4581 9.97834 15.0676 10.043 14.8668 10.3237L11.7861 14.6268C11.702 14.7243 11.5966 14.7454 11.5401 14.7492C11.4821 14.753 11.3706 14.7457 11.2724 14.6535L9.28149 12.7107C9.03443 12.4695 8.63875 12.4745 8.39768 12.7214C8.15659 12.9685 8.1614 13.3642 8.40847 13.6053L10.4028 15.5515C10.4047 15.5533 10.4066 15.5552 10.4085 15.5569C10.7074 15.8416 11.1065 15.9999 11.5171 15.9999C11.5524 15.9999 11.5878 15.9988 11.6232 15.9964C12.0705 15.9666 12.4881 15.7491 12.769 15.3996C12.7762 15.3906 12.7832 15.3813 12.79 15.3719L15.8832 11.0513C16.0841 10.7706 16.0194 10.3802 15.7388 10.1793Z",
    fill: "#3F4752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18747 11.4375C8.53264 11.4375 8.81246 11.1577 8.81246 10.8125C8.81246 10.4673 8.53264 10.1875 8.18747 10.1875C7.84229 10.1875 7.56247 10.4673 7.56247 10.8125C7.56247 11.1577 7.84229 11.4375 8.18747 11.4375Z",
    fill: "#3F4752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11.4375C3.84517 11.4375 4.125 11.1577 4.125 10.8125C4.125 10.4673 3.84517 10.1875 3.5 10.1875C3.15482 10.1875 2.875 10.4673 2.875 10.8125C2.875 11.1577 3.15482 11.4375 3.5 11.4375Z",
    fill: "#3F4752"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.84372 11.4375C6.18889 11.4375 6.46871 11.1577 6.46871 10.8125C6.46871 10.4673 6.18889 10.1875 5.84372 10.1875C5.49854 10.1875 5.21872 10.4673 5.21872 10.8125C5.21872 11.1577 5.49854 11.4375 5.84372 11.4375Z",
    fill: "#3F4752"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_8268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/Login.293638cfaabcedd5b0cfb1d54002af04.svg";
export { ForwardRef as ReactComponent };